import { UserRole } from "@ticketingplatform/api/dist/__generated__/globalTypes";

import { UserFormValues } from "../UserForm/types";

export const USER_INITIAL_VALUES: UserFormValues<false> = {
  input: {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    role: UserRole.ADMIN,
  },
};
